export enum OrderStatusEnum {
  IN_PROCESS = 1,
  READY = 2,
  PAID = 3,
  CANCELLED = 4,
  PENDING = 5,
}

export enum OrderChannelEnum {
  STAFF = 1,
  GUEST_QR = 2,
  GUEST_REMOTE = 3,
  ZALO_MINI_APP = 4,
}

export enum OrderTypeEnum {
  DINE_IN = 1,
  TAKEAWAY = 2,
  DELIVERY = 3,
  OTHER = 4,
}

export enum OrderPaidMethodEnum {
  CASH = 'cash',
  BANK = 'bank',
}
